import Box from "ds/components/Box";
import TableCellGroup from "ds/components/Table/Row/CellGroup";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import styles from "./styles.module.css";

type SpaceDetailsAccessNameCellProps = {
  id: string;
  name: string;
  /** Omitted on session rows: a login-policy principal has no managed-user page to open. */
  href?: string;
  isExpandable: boolean;
  isExpanded: boolean;
  onToggle: () => void;
};

const SpaceDetailsAccessNameCell = ({
  id,
  name,
  href,
  isExpandable,
  isExpanded,
  onToggle,
}: SpaceDetailsAccessNameCellProps) => {
  const label = (
    <Box zeroMinWidth>
      {href ? (
        <TableCellLink href={href}>{name}</TableCellLink>
      ) : (
        <TableCellText>{name}</TableCellText>
      )}
    </Box>
  );

  return (
    <TableSimpleCell id={id} role="rowheader">
      {isExpandable && (
        <TableCellGroup
          isActive
          isGroupOpen={isExpanded}
          onPress={onToggle}
          title={`Toggle ${name} roles`}
        >
          {label}
        </TableCellGroup>
      )}

      {/* Reserve the chevron's width so non-expandable names align with expandable ones. */}
      {!isExpandable && (
        <Box align="center" gap="medium" zeroMinWidth>
          <span className={styles.chevronSpacer} aria-hidden />
          {label}
        </Box>
      )}
    </TableSimpleCell>
  );
};

export default SpaceDetailsAccessNameCell;
